<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M127.923 60.1565C127.315 60.1501 126.714 60.1373 126.106 60.1373C67.3472 60.1373 21.2544 97.1037 20.672 155.491H127.923V60.1565Z"
      class="fill-brand-300"
    />
    <path
      d="M46.9888 155.491H127.923V60.1565C107.699 61.6861 51.3344 86.4285 46.9888 155.491Z"
      class="fill-secondary-500"
    />
    <path
      d="M127.923 141.341V117.481H55.8784C52.7552 124.637 50.2848 132.573 48.704 141.341H127.93H127.923Z"
      class="fill-brand-100"
    />
    <path
      d="M83.424 80.8669C76.8384 86.3453 70.4832 93.0269 64.9664 101.065H127.923V80.8669H83.424Z"
      class="fill-brand-100"
    />
    <path
      d="M139.392 36.995C136.659 34.8382 132.653 35.4398 130.419 38.1086L129.478 39.2286V37.9806C129.478 34.499 126.797 31.4654 123.315 31.363C119.718 31.2542 116.762 34.1406 116.762 37.7182V39.459L115.635 38.115C113.395 35.4462 109.395 34.851 106.662 37.0014C103.834 39.235 103.43 43.3374 105.728 46.0766L112.832 55.6254C115.821 59.4078 118.995 61.1102 123.027 61.1102C127.059 61.1102 129.216 60.5534 132.518 56.9118C132.813 56.5918 133.082 56.2398 133.331 55.8878L140.326 46.0766C142.624 43.3374 142.221 39.2286 139.392 37.0014V36.995Z"
      fill="fill-purple"
    />
    <path
      d="M247.424 155.485H8.55679C6.656 155.485 5.12 157.021 5.12 158.921V165.961C5.12 167.862 6.656 169.398 8.55679 169.398H118.163V197.808C118.163 197.904 118.163 198 118.144 198.096C117.587 202.569 115.136 205.411 112.147 206.857C111.194 207.318 110.138 207.529 109.075 207.529H94.1888C84.7104 207.529 77.0112 215.005 76.6464 224.355H179.334C178.97 215.005 171.27 207.529 161.792 207.529H146.861C145.805 207.529 144.755 207.325 143.802 206.864C140.87 205.449 138.458 202.704 137.83 198.397C137.818 198.288 137.805 198.179 137.805 198.07V169.405H247.411C249.312 169.405 250.848 167.869 250.848 165.968V158.928C250.848 157.027 249.312 155.491 247.411 155.491L247.424 155.485Z"
      class="fill-brand-500"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Budget'
  }
</script>
